import Grid, { GridProps } from '@mui/material/Grid';

export const GridContainer = (props: GridProps) => (
  <Grid container spacing={4} {...props} />
);

export const GridContainerMediumMaxWidth = (props: GridProps) => (
  <Grid container spacing={4} sx={{ maxWidth: '480px' }} {...props} />
);

export const GridContainerFullWidth = (props: GridProps) => (
  <Grid container spacing={4} width={1} {...props} />
);

export const GridContainerFlex = (props: GridProps) => (
  <Grid container spacing={4} mb={2} display="flex" {...props} />
);

export const GridGrow = (props: GridProps) => <Grid size="grow" {...props} />;

export const GridCompact1 = (props: GridProps) => (
  <Grid size={{ compact: 1 }} {...props} />
);

export const GridCompact2 = (props: GridProps) => (
  <Grid size={{ compact: 2 }} {...props} />
);

export const GridCompact3 = (props: GridProps) => (
  <Grid size={{ compact: 3 }} {...props} />
);

export const GridCompact4 = (props: GridProps) => (
  <Grid size={{ compact: 4 }} {...props} />
);

export const GridCompact6 = (props: GridProps) => (
  <Grid size={{ compact: 6 }} {...props} />
);

export const GridCompact8 = (props: GridProps) => (
  <Grid size={{ compact: 8 }} {...props} />
);

export const GridCompact9 = (props: GridProps) => (
  <Grid size={{ compact: 9 }} {...props} />
);

export const GridCompact10 = (props: GridProps) => (
  <Grid size={{ compact: 10 }} {...props} />
);

export const GridCompact12 = (props: GridProps) => (
  <Grid size={{ compact: 12 }} {...props} />
);

export const GridCompact12To4ExtraLarge = (props: GridProps) => (
  <Grid
    size={{ compact: 12, medium: 6, expanded: 6, large: 6, extralarge: 4 }}
    {...props}
  />
);

export const GridInCustomSizes = (props: GridProps) => (
  <Grid size={{ compact: 2, medium: 4 }} {...props} />
);

export const GridContainerAlignCenter = (props: GridProps) => (
  <Grid container spacing={4} sx={{ alignItems: 'center' }} {...props} />
);

export const GridContainerFieldArrayDrawer = (props: GridProps) => (
  <Grid
    container
    spacing={4}
    size={{ medium: 2 }}
    sx={{
      width: (theme) => theme.spacing(10),
      padding: (theme) => theme.spacing(5),
      display: 'flex'
    }}
    {...props}
  />
);
